'use client';

import '@/utils/validationLocale.ts';

import { NuqsAdapter } from 'nuqs/adapters/next/app';
import type { PropsWithChildren } from 'react';

import ProgressBarProvider from '@/components/progress-bar';
import { Toaster } from '@/components/ui/toaster';
import TanstackQueryProvider from '@/providers/query';

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <NuqsAdapter>
      <TanstackQueryProvider>
        <ProgressBarProvider>
          <div vaul-drawer-wrapper="" className="bg-background">
            {children}
          </div>
          <Toaster />
        </ProgressBarProvider>
      </TanstackQueryProvider>
    </NuqsAdapter>
  );
};
